import { useEffect } from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EmployeesTable } from './EmployeesTable/EmployeesTable'

const RequestsPage = () => {
  useEffect(() => {
    track(trackingEvents.salaryAdvance.viewEmployees)
  }, [])

  return (
    <ResponsivePage.Body variant="full">
      <EmployeesTable />
    </ResponsivePage.Body>
  )
}

export default RequestsPage
